import { call, put, takeLatest } from "redux-saga/effects";
import { callDealsPreLoginGetApi } from "../Context/dealsPreLoginApi";
import {
  onGetDealsPreLogin,
  onGetDealsPreLoginError,
  onGetDealsPreLoginSuccess,
} from "../Store/Slices/dealsDataSlice";

function* GetDealsPreLogin({ payload }) {
  try {
    const response = yield call(callDealsPreLoginGetApi, payload);
    if (response.responseCode === "200") {
      yield put(
        onGetDealsPreLoginSuccess({
          data: response.response,
          message: response.responseMessage,
          status_code: response.responseCode,
        })
      );
    } else {
      yield put(
        onGetDealsPreLoginError({
          data: response.response,
          message: response.response?.message,
          status_code: response.responseCode,
        })
      );
    }
  } catch (error) {
    const message = error.response || "Something went wrong";
    yield put(
      onGetDealsPreLoginError({ data: [], message, status_code: 400 })
    );
  }
}

export default function* dealsPreLoginSaga() {
  yield takeLatest(onGetDealsPreLogin.type, GetDealsPreLogin);
}


